<template>
  <div
    class="min-w-screen min-h-screen bg-slate-100 flex flex-col justify-center items-center p-5 lg:p-20 overflow-hidden relative"
  >
    <div
      class="min-h-full md:w-1/2 rounded-3xl bg-white shadow-xl p-5 sm:p-10 text-gray-800 relative items-center text-left"
    >
      <div class="w-full md:w-full">
        <div class="text-gray-600 font-light">
          <form class="flex flex-col gap-y-10" @submit.prevent="submit">
            <h1
              class="text-center text-3xl md:text-4xl xl:text-5xl text-slate-400"
            >
              Recupera tu contraseña
            </h1>
            <div class="flex flex-col md:flex-row gap-y-5">
              <label for="email" class="font-bold"
                >Por favor ingresa tu correo electrónico:</label
              >
              <input
                class="w-full"
                v-model="form.email"
                type="email"
                placeholder="tucorreo@ejemplo.com"
                id="email"
                required
                autofocus
              />
            </div>
            <button class="form__btn z-10" style="width: 100%" type="submit">
              Recuperar contraseña
            </button>
          </form>
          <button
            class="text-lg font-light outline-none focus:outline-none transform transition-all hover:scale-110 text-yellow-500 hover:text-yellow-600 mr-5"
          >
            <i class="mdi mdi-arrow-left mr-2"></i>
            <router-link to="/">Volver</router-link>
          </button>
        </div>
      </div>
    </div>
    <div
      class="w-64 md:w-96 h-96 md:h-full bg-green-600 bg-opacity-30 absolute -top-64 md:-top-96 right-20 md:right-32 rounded-full pointer-events-none -rotate-45 transform"
    ></div>
    <div
      class="w-96 h-full bg-red-600 bg-opacity-20 absolute -bottom-96 right-64 rounded-full z-1 pointer-events-none -rotate-45 transform"
    ></div>
  </div>

  <!-- <div class="flex items-end justify-end fixed bottom-0 right-0 mb-4 mr-4 z-10">
    <div></div>
  </div> -->
</template>

<script>
import { swal } from "@/common/constants/variables";

import { reactive } from "vue";
import { useRouter } from "vue-router";
import {generateTextError, useAPIRest, verifyHttpCode} from "@/common/constants";

export default {
  name: "RecuperarContrasena",
  setup() {
    const form = reactive({
      email: "",
    });
    const router = useRouter();
    const submit = async () => {
      await swal
        .fire({
          title: "¿Esta seguro de cambiar la contraseña?",
          text: "Se enviará un enlace de verificación de cambio de contraseña a su bandeja de entrada",
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: "Envíar enlace de verificación",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: async () => await useAPIRest(process.env.VUE_APP_NEST_AUTH_REMEMBER, 'POST', undefined, form, undefined, 'application/json', 'include'),
          allowOutsideClick: () => !swal.isLoading(),
        })
        .then(async (result) => {
          if (result.isConfirmed && result.value !== true) {
            const resJSON = result.value;
            const {statusCode} = resJSON;
            delete resJSON['statusCode'];
            const textoError = generateTextError(resJSON);
            if (verifyHttpCode(statusCode, 'success'))
              swal
                .fire("¡Enlace de verificación enviado!", "", "success")
                .then(() => router.push("/"));
            else await swal.fire(textoError, "", "error");
          }
        });
    };
    return {
      form,
      submit,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/main.scss";

.form {
  width: 100%;

  &__group {
    &:not(:last-child) {
      margin-bottom: 2rem;
    }
  }

  &__input {
    height: 2rem;
    width: 100%;
    padding: 2rem 1rem;
    border-radius: 4px;
    color: $color__primary;
    border: 1px solid $color__secondary;

    &:focus,
    &:active {
      outline: none;
    }

    &:placeholder-shown,
    &::placeholder {
      color: $color__secondary;
    }
  }

  &__label {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    color: $color__primary;
  }

  &__btn {
    width: 100px;
    @include customBorder($color__primary, $color__secondary);
    color: $color__white;
    padding: 1rem;
    border-radius: 4px;
    margin-bottom: 1rem;

    cursor: pointer;
  }
}

.errorLogin {
  @include customBorder(#fbe6e1, $color__gray--dark);

  &__text {
    color: $color__gray--dark;
  }
}
</style>
